<template>
  <svg viewBox="0 0 113.97 113.97" v-if="id === 1">
    <path
      class="cls-1"
      d="M63.31,57.49c-1.21.4-2.29,1.07-3.19,1.92l43.06,43.06-.71.71-43.04-43.03c-1.11,1.35-1.82,3.04-1.94,4.89v48.93h-1v-49.02c-.12-1.83-.82-3.5-1.92-4.83L11.51,103.18l-.71-.71,43.09-43.09c-.86-.83-1.9-1.48-3.06-1.89H0v-1h50.87c1.14-.42,2.17-1.07,3.02-1.89L10.8,11.51l.71-.71,43.06,43.06c1.1-1.33,1.8-3,1.92-4.83V0h1v49.05c.12,1.82.81,3.49,1.9,4.83L102.47,10.8l.71.71-43.12,43.12c.82.8,1.82,1.44,2.92,1.86h50.99v1h-50.66Z"
    />
  </svg>

  <svg v-else-if="id === 2" viewBox="0 0 109.21 95.41">
    <path
      class="cls-1"
      d="M105.33,94.81l-.79.6c-.34-.44-34.66-44.47-104.52-47.2l-.02-.5.02-.5C69.88,44.48,104.2.44,104.54,0l.79.6c-.32.42-30.69,39.43-92.37,46.61h87.7v-8.05c0,4.72,3.83,8.55,8.55,8.55-4.72,0-8.55,3.82-8.55,8.54v-8.04H12.96c30.15,3.51,52.43,14.56,66.39,23.81,17.24,11.42,25.9,22.67,25.98,22.79Z"
    />
  </svg>

  <svg v-else-if="id === 3" viewBox="0 0 104.81 104.81">
    <path
      id="Tracé_2709"
      data-name="Tracé 2709"
      class="cls-1"
      d="M60.96,52.44c-4.7,0-8.51,3.79-8.55,8.49,0-4.72-3.83-8.54-8.55-8.54h0c4.7,0,8.52-3.8,8.55-8.5,0,4.72,3.82,8.55,8.54,8.55h0"
    />
    <path
      class="cls-1"
      d="M52.41,104.81C23.51,104.81,0,81.3,0,52.41S23.51,0,52.41,0s52.41,23.51,52.41,52.41-23.51,52.41-52.41,52.41ZM52.41,1C24.06,1,1,24.06,1,52.41s23.06,51.41,51.41,51.41,51.41-23.06,51.41-51.41S80.75,1,52.41,1Z"
    />
  </svg>

  <svg v-else-if="id === 4" viewBox="0 0 105.43 105.43">
    <path
      id="Tracé_2715"
      data-name="Tracé 2715"
      class="cls-1"
      d="M58.77,52.74c-3.33,0-6.03,2.69-6.06,6.01,0-3.34-2.71-6.05-6.05-6.05,3.33,0,6.04-2.69,6.06-6.02,0,3.34,2.71,6.05,6.05,6.06h0,0Z"
    />
    <polygon
      class="cls-1"
      points="68.54 .71 19.1 50.15 18.39 49.44 52.01 15.83 36.89 .71 37.6 0 52.72 15.12 67.83 0 68.54 .71"
    />
    <polygon
      class="cls-1"
      points="50.26 86.45 49.56 87.15 15.83 53.42 .71 68.54 0 67.83 15.12 52.71 0 37.6 .71 36.89 50.26 86.45"
    />
    <polygon
      class="cls-1"
      points="53.42 89.6 68.54 104.72 67.83 105.43 52.71 90.31 37.6 105.43 36.89 104.72 86.33 55.29 87.03 55.99 53.42 89.6"
    />
    <polygon
      class="cls-1"
      points="90.32 52.72 105.43 67.83 104.72 68.54 55.18 19 55.89 18.29 89.61 52.01 104.72 36.89 105.43 37.6 90.32 52.72"
    />
  </svg>

  <svg v-else-if="id === 5" viewBox="0 0 183.21 92.48">
    <path
      class="cls-1"
      d="M137.32,1.41l-44.83,44.83,44.83,44.83,36.49-36.44-5.11-5.11c3,3,7.86,3,10.87,0-3,3-3,7.86-.01,10.86l-5.04-5.04-37.2,37.14L46.25,1.41,1.42,46.24l44.83,44.83,42.87-42.88.71.71-43.58,43.58L0,46.24,46.25,0l45.54,45.54L137.32,0l45.89,45.89-.71.7L137.32,1.41Z"
    />
  </svg>

  <svg v-else-if="id === 6" viewBox="0 0 108.18 108.17">
    <path
      class="cls-1"
      d="M108.18,107.17v1H0V0h1v105.16L41.22,7.99l.92.38L1.93,105.53,70.18,37.17l-5.7-5.7c3.34,3.33,8.75,3.33,12.09,0-3.34,3.33-3.34,8.74-.01,12.08l-5.68-5.68L2.63,106.25l97.15-40.26.39.92L3.02,107.17h105.16Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'FloatingSvg',
  props: {
    id: {
      type: Number,
      default: 1,
    },
  },
}
</script>

<style scoped>
.cls-1 {
  fill: currentColor;
  stroke-width: 0px;
}
</style>
